module.exports = __webpack_public_path__ + "static/media/report.9e17af3e.svg";